import "./utils/bugsnag"; // initialize bugsnag before everything else
// tslint:disable-next-line:ordered-imports
import "@8x8/fonts/style.css";
import "bootstrap/dist/css/bootstrap.css";
import "draft-js/dist/Draft.css";

import { getFlag } from "./reducers/persist";
import "./styles/main.scss";
import { App } from "./ui/Main";
// tslint:disable-next-line:ordered-imports
import { render } from "./ui/AppBody";

const el = document.getElementById("chalet");
if (el) {
    render(el);
} else {
    document.body.innerHTML = "Failed to load the application: #chalet element not found.";
}

const { hot } = module;
if (hot) {
    const cp = "Cypress" in window;
    let hotReload = getFlag(App.rootStore.getState(), "hot_reload");
    if (cp || hotReload) {
        hot.accept();
    }
    const onChanged = () => {
        const reload = getFlag(App.rootStore.getState(), "hot_reload");
        if (reload !== hotReload) {
            hotReload = reload;
            if (hotReload) {
                hot.accept();
            } else {
                hot.decline();
            }
        }
    };
    const unsubscribe = App.rootStore.subscribe(onChanged);
    hot.dispose(() => {
        // tslint:disable-next-line:no-console
        console.log("re-rendered");
        unsubscribe();
    });
}
